<template>
  <div>
    <sub-header bizCd="02"/>
    <div class="sub_visual sub13">
      <div class="container">
        <div class="sub_txt">
          <div class="tit">AI CLASS</div>
          <div class="comment">
            AI 시대, <br class="mobile840hidden">배움은 합격에서 멈추지 않습니다.<br>
            다시 시작하는 지금, <br class="mobile840hidden">에듀윌과 함께 AI로 앞서 나가세요.
          </div>
        </div>
      </div>
    </div>
    <div class="contents aos-all aiclass">
      <div class="container">
        <div class="sec">
          <div class="sub_tit">
            <p class="mx200">AI CLASS</p>
          </div>
          <div class="con">
            <div class="txt txt_line2">누구나 AI를 배우고 바로 쓸 수 있도록, <br class="mobile840hidden">에듀윌이 준비한 AI 교육 과정입니다.</div>
            <div class="aic-box">
              <p class="aic-box-tit">AI CLASS는 이렇게 배웁니다</p>
              <ul class="aic-feature">
                <li>
                  <p class="tit">국가공인 AI 자격</p>
                  <p class="desc">AICE 자격 대비 <br class="mobile840hidden">교육</p>
                </li>
                <li>
                  <p class="tit">입문부터 실무까지</p>
                  <p class="desc">AI가 처음인 사람도 <br class="mobile840hidden">단계별로</p>
                </li>
                <li>
                  <p class="tit">실습 중심</p>
                  <p class="desc">직접 따라 하며 <br class="mobile840hidden">결과물 완성</p>
                </li>
                <li>
                  <p class="tit">온·오프라인 교육</p>
                  <p class="desc">온라인 강의부터 <br class="mobile840hidden">현장 교육까지</p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="sec">
          <div class="sub_tit">교육 현장</div>
          <div class="con">
            <div class="txt txt_line2">온라인 강의부터 <br class="mobile840hidden">오프라인 캠프, 기업·협회 교육까지 <br class="mobile840hidden">AI 교육의 현장을 넓혀가고 있습니다.</div>
            <div class="aic-box aic-field">
              <p class="aic-box-tit">온라인·오프라인·기업 교육</p>
              <div class="swiper-container aic-field-slider">
                <ul class="swiper-wrapper">
                  <li class="swiper-slide">
                    <p class="thumb"><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_field01.jpg" alt="온라인 강의"></p>
                    <p class="tit">온라인 강의</p>
                    <p class="desc">AICE·콘텐츠 생성·자동화·바이브코딩</p>
                  </li>
                  <li class="swiper-slide">
                    <p class="thumb"><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_field02.jpg" alt="오프라인 AX 캠프"></p>
                    <p class="tit">오프라인 AX 캠프</p>
                    <p class="desc">직무별 AX 특강</p>
                  </li>
                  <li class="swiper-slide">
                    <p class="thumb"><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_field03.jpg" alt="기업·협회 교육"></p>
                    <p class="tit">기업·협회 교육</p>
                    <p class="desc">임직원 AX 교육·협회 위탁 과정</p>
                  </li>
                </ul>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="sec">
          <div class="sub_tit">교육 분야</div>
          <div class="con">
            <div class="txt txt_line2">AI 시대에 꼭 필요한 역량을 분야별로 다룹니다.</div>
            <div class="aic-box">
              <p class="aic-box-tit">AI 입문부터 직무 자동화, 자격 취득까지</p>
              <ul class="aic-area">
                <li>
                  <p class="tit">AI 업무 자동화</p>
                  <p class="desc">반복 업무를 AI에게 넘기고, <br class="mobile840hidden">사람은 판단이 필요한 일에 집중합니다.</p>
                  <p class="tag"><span>#워크플로 자동화</span><span>#AI 에이전트</span><span>#Claude Cowork</span><span>#노코드 사내 ERP</span></p>
                </li>
                <li>
                  <p class="tit">바이브코딩·AI 빌더</p>
                  <p class="desc">코딩 경험이 없어도 업무에 필요한 툴과 <br class="mobile840hidden">페이지를 직접 만듭니다.</p>
                  <p class="tag"><span>#업무툴 직접 제작</span><span>#랜딩페이지·웹사이트</span><span>#코드 없는 에이전트</span><span>#1:1 피드백</span></p>
                </li>
                <li>
                  <p class="tit">AI 콘텐츠 제작</p>
                  <p class="desc">영상·숏폼·카드뉴스를 외주 없이 <br class="mobile840hidden">AI로 기획하고 제작합니다.</p>
                  <p class="tag"><span>#AI 영상 제작</span><span>#숏폼·카드뉴스 자동화</span><span>#마케팅 콘텐츠</span><span>#브랜딩</span></p>
                </li>
                <li>
                  <p class="tit">직무·업종 특화</p>
                  <p class="desc">직무와 업종의 실제 업무에 맞춘 <br class="mobile840hidden">AI 활용법을 다룹니다.</p>
                  <p class="tag"><span>#마케팅</span><span>#교사·공공</span><span>#부동산 중개</span><span>#소상공인·1인 사업자</span></p>
                </li>
                <li>
                  <p class="tit">AI 국가공인 자격</p>
                  <p class="desc">AI 활용 역량을 국가공인 자격 취득으로 <br class="mobile840hidden">증명합니다.</p>
                  <p class="tag"><span>#AICE Basic</span><span>#AICE Associate</span><span>#공인 강사 직강</span></p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="sec">
          <div class="sub_tit">수강 대상</div>
          <div class="con">
            <div class="txt txt_line2">AI가 처음인 사람부터 실무자까지, <br class="mobile840hidden">누구나 시작할 수 있습니다.</div>
            <div class="aic-box">
              <p class="aic-box-tit">이런 분들이 배웁니다</p>
              <ul class="aic-target">
                <li>
                  <p class="tit">AI 입문자</p>
                  <p class="img"><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_target01.png" alt=""></p>
                </li>
                <li>
                  <p class="tit">직장인</p>
                  <p class="img"><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_target02.png" alt=""></p>
                </li>
                <li>
                  <p class="tit">취업준비생·<br class="mobile840hidden">커리어 전환</p>
                  <p class="img"><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_target03.png" alt=""></p>
                </li>
                <li>
                  <p class="tit">1인 사업자·<br class="mobile840hidden">소상공인</p>
                  <p class="img"><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_target04.png" alt=""></p>
                </li>
              </ul>
              <div class="aic-target-plus">
                <span class="ico-plus"></span>
                <p class="desc">에듀윌 합격생 출신 <br class="pc840hidden">공인중개사 대표님, <br class="mobile840hidden">관리사무소 소장님, 현직 공무원…</p>
              </div>
            </div>
            <div class="aic-box">
              <p class="aic-box-tit">현업에서 쓰는 도구 그대로 배웁니다</p>
              <ul class="aic-tool">
                <li><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_tool01.png" alt="ChatGPT"></li>
                <li><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_tool02.png" alt="Claude"></li>
                <li><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_tool03.png" alt="Gemini"></li>
                <li><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_tool04.png" alt="Midjourney"></li>
                <li><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_tool05.png" alt="OpenAI"></li>
                <li><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_tool06.png" alt="make"></li>
                <li><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_tool07.png" alt="zapier"></li>
                <li><img src="//img.eduwill.net/resources/b2b/live/images/aiclass_tool08.png" alt="n8n"></li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 수강 후기 -->
        <div class="sec">
          <div class="sub_tit">수강 후기</div>
          <div class="con">
            <div class="txt txt_line2">수강생들이 직접 만든 결과물로 증명합니다.</div>
            <div class="aic-box aic-review">
              <div class="swiper-container aic-review-slider">
                <ul class="swiper-wrapper">
                  <li class="swiper-slide">
                    <p class="tit">업무 관리 앱 제작</p>
                    <p class="desc">
                      영업 지원 업무만 하던 제가 <strong>거래처별 견적서를 자동으로 <br class="pc840hidden">만들어주는 도구를 직접 구현</strong>했어요.<br>
                      반복 작업이 사라지니 진짜 중요한 일에 집중하게 됐습니다.
                    </p>
                    <p class="name">HRBP · 김**</p>
                  </li>
                  <li class="swiper-slide">
                    <p class="tit">엑셀 수식 자동화</p>
                    <p class="desc">
                      엑셀 수식 붙잡고 야근하던 사무직인데, 매달 하던 정산 자료 <br class="pc840hidden">정리를 자동화 툴로 만들어 <strong>반나절 일을 10분으로</strong> 줄였어요.<br>
                      이제 칼퇴근합니다.
                    </p>
                    <p class="name">사무직 · 이**</p>
                  </li>
                  <li class="swiper-slide">
                    <p class="tit">리포트 자동화</p>
                    <p class="desc">
                      기획만 하던 비전공자인데, <strong>막막했던 회사소개서 리뉴얼을 AI로 하루 만에 완성</strong>했어요. <br>AI 홍수 속에서 내 무기를 찾았습니다.
                    </p>
                    <p class="name">퍼포먼스 마케터 · 박**</p>
                  </li>
                  <li class="swiper-slide">
                    <p class="tit">견적서 자동화</p>
                    <p class="desc">
                      해당 직무에 있으면서 중요하면서도 가장 귀찮은 일이 견적서인데, <strong>자동화에 성공</strong>했어요. <br>
                      이제 그 시간에 다른 업무를 할 수 있습니다.
                    </p>
                    <p class="name">영업지원 · 최**</p>
                  </li>
                  <li class="swiper-slide">
                    <p class="tit">실적 대시보드 제작</p>
                    <p class="desc">
                      숫자만 다루던 재무 담당인데, <strong>월간 실적 대시보드</strong>를 만들어 매번 수기로 만들던 보고서를 없애고 팀 회의에서도 한눈에 보고 좋아합니다.</p>
                    <p class="name">재무·회계 실무자 · 정**</p>
                  </li>
                  <li class="swiper-slide">
                    <p class="tit">랜딩페이지 구현</p>
                    <p class="desc">
                      혼자 다 해야 하는데 멤버십 <strong>랜딩페이지를 0에서 직접 구현</strong>했어요. <br>외주 없이 만든다는 게 이렇게 뿌듯할 줄 몰랐습니다.</p>
                    <p class="name">1인 사업자 · 한**</p>
                  </li>
                  <li class="swiper-slide">
                    <p class="tit">회의록 자동화</p>
                    <p class="desc">
                      매주 팀 회의록 정리가 고역이었는데, AI로 <strong>회의 내용을 자동 요약·정리하는 흐름을 만들어 시간을 절반으로</strong> 줄였어요. <br>
                      기록에 쓰던 힘을 이제 실무에 씁니다.</p>
                    <p class="name">총무·기획 · 오**</p>
                  </li>
                  <li class="swiper-slide">
                    <p class="tit">온보딩 사이트 배포</p>
                    <p class="desc">
                      코딩 한 줄 몰랐는데 <strong>하루 만에 온보딩 사이트를 만들어 배포</strong>까지 끝냈어요. <br>
                      "나도 되네?"를 처음 경험했습니다.</p>
                    <p class="name">HR 실무자 · 서**</p>
                  </li>
                </ul>
              </div>
              <button type="button" class="aic-review-prev" aria-label="이전 후기"></button>
              <button type="button" class="aic-review-next" aria-label="다음 후기"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="float_counsel m_hidden">
      <div class="group-wrap">
        <div class="group">
          <div class="text">임직원 전용<br>에듀윌 교육몰</div>
          <div class="button"><a href="//img.eduwill.net/resources/b2b/live/에듀윌 임직원 전용 교육몰 서비스.pdf"
                                 target="_blank">브로슈어 다운로드</a>
          </div>
          <div class="ico-hand"></div>
        </div>
        <div class="group">
          <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
          <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
          <div class="ico-hand"></div>
        </div>
      </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
      <a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
  </div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
  name: "ContentAiclass",
  components: {SubHeader},
  data() {
    return {}
  },

  computed: {
  },

  methods: {
    showCounsel(v) {
      eventBus.$emit("show-counsel", v);
    },
    closeCurriculum(v) {
      $('.curriculum_pop_' + v).bPopup().close();
    },
    showCurriculum(v) {
      $('.curriculum_pop_' + v).bPopup();
    }
  },

  created() {
  },
  beforeMount() {
  },
  mounted() {
    AOS.init({ easing: 'ease-in-out-sine' })

    $(".pa_slider_scroll").simplyScroll({
      customClass:'vert',
      speed: 5,
      pauseOnHover : true
    });

    // 교육 현장 : PC 3단 고정 / MO(840 이하) 슬라이드
    new Swiper(".aiclass .aic-field-slider", {
      slidesPerView: 3,
      spaceBetween: 10,
      allowTouchMove: false,
      initialSlide: window.innerWidth <= 840 ? 1 : 0,
      pagination: {
        el: ".aiclass .aic-field-slider .swiper-pagination",
        clickable: true
      },
      breakpoints: {
        840: {
          slidesPerView: 'auto',
          spaceBetween: 12,
          centeredSlides: true,
          allowTouchMove: true,
          loop: true,
          autoplay: {
            delay: 4000,
          },
        }
      }
    });

    // 수강 후기
    new Swiper(".aiclass .aic-review-slider", {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10,
      navigation: {
        prevEl: ".aiclass .aic-review-prev",
        nextEl: ".aiclass .aic-review-next"
      },
      breakpoints: {
        840: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        }
      }
    });
  },
}
</script>

<style scoped>

</style>